/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type accessBlocked_viewer = {
    readonly id: string;
    readonly company: {
        readonly id: string;
        readonly accessBlocked: boolean | null;
    } | null;
    readonly " $refType": "accessBlocked_viewer";
};
export type accessBlocked_viewer$data = accessBlocked_viewer;
export type accessBlocked_viewer$key = {
    readonly " $data"?: accessBlocked_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"accessBlocked_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "accessBlocked_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accessBlocked",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
(node as any).hash = 'e6204168de6dcac5341b3f0f2ae55756';
export default node;
